import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  domain: string;
  clientId: string;
  audience?: string;
  redirectUri: string;
  cacheLocation?: 'localstorage' | 'memory';
  useRefreshTokens?: boolean;
  connection?: string; // Passwordless connection name (e.g., 'email')
  portalKey: string; // Portal key: "client" | "member" | "attorney"
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');

/**
 * @deprecated Use environment.auth and inject AUTH_CONFIG instead.
 * Kept for backward compatibility with other portals.
 */
export const authConfig: AuthConfig = {
  domain: 'YOUR_DOMAIN',
  clientId: 'YOUR_CLIENT_ID',
  audience: 'YOUR_API_AUDIENCE',
  redirectUri: window.location.origin,
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  portalKey: '' // Default value, should be overridden by portal-specific configs
};
